module.exports = __webpack_public_path__ + "static/img/yimg.12231308.png";